import { QuantityNames } from 'merchandise-lib/constants/QuantityName';
import QuantityPackApiName from 'merchandise-lib/constants/QuantityPackApiName';
import { TRACKING_SOURCES } from '../../v2/constants/tracking/TrackingSources';
const PRODUCT_LINES = ['MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS', 'COMMERCE'];
export const VALID_PRODUCT_LINES = new Set(PRODUCT_LINES);
const PRODUCT_LEVELS = ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
export const VALID_PRODUCT_LEVELS = new Set(PRODUCT_LEVELS);
const PAID_PRODUCT_LEVELS = ['STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
export const VALID_PAID_PRODUCT_LEVELS = new Set(PAID_PRODUCT_LEVELS);

/*
 * All valid SkuCategoryName string values - this list should match the generated enum exactly
 * If a new value is added to SkuCategoryName, TypeScript will error.
 * Corresponding value can be anything, this is mainly for type-checking and to ensure that the list is exhaustive.
 */
export const VALID_SKU_CATEGORY_NAMES = {
  SALES_PRODUCTS: true,
  ADD_ONS: true,
  CONSULTING_SERVICE: true,
  SIDEKICK: true,
  CLASSROOM_TRAINING_SERVICES: true,
  OTHER: true,
  MIGRATION_AND_TEMPLATE_SETUPS: true,
  ONBOARDING_SERVICES: true,
  MARKETING_PRODUCTS: true,
  MARKETING_CONTACTS: true,
  PREMIER_SERVICES: true,
  SERVICE_HUB_PRODUCTS: true,
  CMS_HUB_PRODUCTS: true,
  OPERATIONS_HUB_PRODUCTS: true,
  CORE_PLATFORM_SEATS: true,
  CRM_SUITE: true,
  MARKETING_PLUS_SUITE: true,
  BREEZE_PRODUCTS: true,
  BREEZE_OVERAGE_PRODUCTS: true,
  HUBSPOT_CREDITS: true,
  COMMERCE_PRODUCTS: true,
  ENTERPRISE_FLEX_PROGRAM: true,
  ENTERPRISE_FLEX_SEAT: true,
  FRONT_OFFICE_SEATS: true,
  CORE_SEATS: true,
  GTM_SEATS: true,
  OPS_SEATS: true
};
export const VALID_TRACKING_SOURCES = new Set(Object.values(TRACKING_SOURCES));
export const VALID_TTS_PURCHASE_MOTIONS = new Set(['TALK_TO_SALES', 'TALK_TO_SALES_FALLBACK']);
export const VALID_QUANTITY_NAMES = new Set(Object.values(QuantityNames));
export const VALID_QUANTITY_PACK_API_NAMES = new Set(Object.values(QuantityPackApiName));